import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { STATISTIC_PAYMENT_PERIOD } from 'api/query-keys';
import type { TGetPaymentPeriodByUserRes } from 'api/swagger';
import type { IStatisticProfitFilter } from 'shared/stores/use-statistic-profit-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IStatisticProfitFilter;
  paymentTerm?: 'original' | 'scan';
}

export const useGetPaymentPeriodStatistics = (params: IParams) => {
  const { filters, paymentTerm } = params;

  const filtersWithPaymentTerm = paymentTerm ? { ...filters, paymentTerms: paymentTerm } : filters;
  const qs = new URLSearchParams();
  setFiltersToQs<IStatisticProfitFilter>(qs, filtersWithPaymentTerm);

  return useQuery({
    queryKey: [STATISTIC_PAYMENT_PERIOD, paymentTerm, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetPaymentPeriodByUserRes>(`/v1/statistics/payment-period?${qs.toString()}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!filters.date && !!filters.userId,
  });
};
